// @flow

import GenericRelationResource from 'esm-web-pro/api/resources/GenericRelationResource';

export default class AttachmentResource extends GenericRelationResource {
    basePath: string = 'attachments/{appLabel}/{contentType}/{objectId}/';

    objectPath: string = 'attachments/{appLabel}/{contentType}/{objectId}/{ident}/';

    // $FlowFixMe
    create(appLabel: string, contentType: string, objectId: string, { file, ...rest }) {
        return this.client._request(this.getBasePath(appLabel, contentType, objectId), 'POST',
            { files: { file }, ...rest });
    }
}
